import { render, staticRenderFns } from "./BuyBusiness.vue?vue&type=template&id=8b38e850&"
import script from "./BuyBusiness.vue?vue&type=script&lang=js&"
export * from "./BuyBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports